// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { useAppDispatch } from 'Hooks';
import { InlineNameEditor } from 'Components/InlineNameEditor';
import { updateFolderThunk } from '../folderListThunk';

interface ComponentProps {
  initialFolderName: string;
  folderId: string;
}

export const FolderName: React.FC<ComponentProps> = ({ initialFolderName, folderId }) => {
  const dispatch = useAppDispatch();

  return (
    <InlineNameEditor
      name={initialFolderName}
      ariaLabel="Folder Name"
      fallbackError="Failed to rename folder"
      onSave={(name) => dispatch(updateFolderThunk(folderId, name))}
    />
  );
};

export default FolderName;
